goog.provide("shadow.js.shim.module$src$svg$organisations$other$instagram_svg$default");
shadow.js.shim.module$src$svg$organisations$other$instagram_svg$default = shadow.js.shim.module$src$svg$organisations$other$instagram_svg.default;
